import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { getTranslation, logError } from "../helpers/utils";
import { getInitialData } from "./InitialDataSlice";

export const getProvince = createAsyncThunk(
  "ProvinceSlice/getProvince",
  async (data, { rejectWithValue, getState }) => {
    try {
      // Skip if already loaded (raw data exists)
      const state = getState();
      if (state.province.rawProvinces && state.province.rawProvinces.length > 0) {
        return { langId: data.selLanguageId, res: state.province.rawProvinces, fromCache: true };
      }
      const response = await axios.get(
        `${process.env.REACT_APP_LOCAL_API}/provinces`
      );
      return { langId: data.selLanguageId, res: response.data.data.Provinces };
    } catch (error) {
      logError(error, "ProvinceSlice/getProvince");
      return rejectWithValue(error.response.data);
    }
  }
);

const processProvinces = (state, provinces, langId) => {
  if (!provinces) return;
  state.rawProvinces = provinces; // Store raw for re-translation
  state.province = provinces.map((lang) => {
    let transProvince = { ...lang };
    if (lang.name?.[0]?.text === "Federal") {
      state.federalId = lang._id;
    }
    transProvince.name = getTranslation(lang.name, langId);
    return transProvince;
  });
  state.province = state.province.sort((a, b) =>
    (a.name || '').localeCompare(b.name || '')
  );
};

export const ProvinceSlice = createSlice({
  name: "province",
  initialState: {
    province: [],
    rawProvinces: [], // Store raw data for re-translation
    selProvinceId: "",
    federalId: "",
  },
  reducers: {
    setProvinceId: (state, action) => {
      state.selProvinceId = action.payload;
    },
    getTranslatedProvinces: (state, action) => {
      state.province = action.payload.provinces.map((lang) => {
        let transProvince = { ...lang };
        transProvince.name = getTranslation(lang.name, action.payload.langId);
        return transProvince;
      });
      state.province = state.province.sort((a, b) =>
        (a.name || '').localeCompare(b.name || '')
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProvince.fulfilled, (state, action) => {
        processProvinces(state, action.payload.res, action.payload.langId);
      })
      .addCase(getProvince.rejected, (state, action) => {
        toast.error(action.payload);
      })
      // Listen for initial data load
      .addCase(getInitialData.fulfilled, (state, action) => {
        if (action.payload?.Provinces) {
          state.rawProvinces = action.payload.Provinces;
          // Don't translate yet - wait for language selection
        }
      });
  },
});
export const { getTranslatedProvinces, setProvinceId } = ProvinceSlice.actions;

export default ProvinceSlice.reducer;
